import { ref, inject, reactive,nextTick } from 'vue'

const getCart = async (type?:any) => {
     const $http:any = inject('$http')
     const $store:any = inject('$store'),
     cart_goods:any = ref([])
     if($store.getToken()) { 
          if($store.getCart()) {
            // if(type == 'length') {
              return $store.getCart()
            // } else {
            //   return $store.getCart().datas
            // }
          } else {
            let { data } = await $http.cart() 
            if(data&&data.length>=0){
            data&&data.forEach((item:any) => {
                item.goods_list.forEach((goods_item:any) => {
                    cart_goods.value.push(goods_item)
                })
            });
            // let cart_datas = {
            //   datas:data,
            //   cart_length:cart_goods.value
            // }
          $store.setCart(cart_goods.value)
          return cart_goods.value
        // if(type == 'length') {
        //   return $store.getCart().cart_length
        // } else {
        //   return $store.getCart().datas
        // }
        }
        }
     } else {
      // if(type == 'length') {
        return 0
      // } else {
      //   return []
      // }
     }
  
}
export {
  getCart
}